<template>
  <div class="container">
    <swiper
      ref="mySwiper"
      class="swiper"
      :options="swiperOption"
      @slideChange="onSlideChange"
    >
      <!-- 首页 -->
      <swiper-slide>
        <div class="carouseitem">
          <swiper class="swiper" :options="homeSwiper">
            <swiper-slide v-for="(item, index) in homeImgList" :key="index">
              <img class="homeswiper-img" :src="item.img" alt="" @dblclick="getHomeImg(item.url)">
            </swiper-slide>
          </swiper>
          <img class="carouseitem-hometitle animated" :class="swiperOption.initialSlide == 0 ? 'delay zoomIn' : 'zoomOut'" :src="homeTitle" alt="">
          <img class="carouseitem-bottom" :src="bottomImg" alt="" @click="getNext()">
        </div>
      </swiper-slide>
      <!-- 企业简介 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="introduceImg" alt="">
          </div>
          <div class="carouseitem-con">
            <div class="carintro-con">
              <div class="carintro-title animated" :class="swiperOption.initialSlide == 1 ? 'delay bounceInLeft' : 'fadeOutLeft'">
                <div>企业简介</div>
                <img :src="homeEn" alt="">
              </div>
              <div class="carintro-desc animated" :class="swiperOption.initialSlide == 1 ? 'delay bounceInRight' : 'fadeOutRight'">
                <span>贵州汉方药业有限公司（以下简称：汉方药业）成立于1996年，注册资本22154.87万元，主营现代中成药的生产、研发、销售。现有员工246人，高级职称6人，中级职称（含执业药师）16人，初级职称10人，本科以上学历87人。公司现有专利37项，其中发明专利14项，实用新型专利10项，外观专利4项，有效商标31个。涉及3类、5类、10类、40类、41类、42类，共11类。<span class="carintro-desc-more" @click="getIntroMore">【查看更多】</span></span>
                <div class="carintro-desc-line"></div>
              </div>
            </div>
            <div class="carintro-list animated" :class="swiperOption.initialSlide == 1 ? 'delay bounceInUp' : 'fadeOutDown'" @click="getIntroMore">
              <div class="introitem">
                <img class="introitem-bg" :src="homeImg" alt="">
                <img class="introitem-play" :src="introPlay" alt="">
              </div>
              <div class="introitem bg1">
                <div class="introitem-title">
                  <div class="introitem-name">企业纪元</div>
                  <div class="introitem-en">COMPANY ERA</div>
                </div>
                <div class="introitem-more">
                  <img src="static/images/home/icon-right01.png" alt="">
                </div>
              </div>
              <div class="introitem">
                <img class="introitem-bg" :src="introBg" alt="">
              </div>
              <div class="introitem bg2">
                <div class="introitem-title">
                  <div class="introitem-name">组织架构</div>
                  <div class="introitem-en">ORGANIZATIONAL STRUCTURE</div>
                </div>
                <div class="introitem-more">
                  <img src="static/images/home/icon-right01.png" alt="">
                </div>
              </div>
              <div class="introitem bg3">
                <div class="introitem-title">
                  <div class="introitem-name">企业概况</div>
                  <div class="introitem-en">COMPANY PROFILE</div>
                </div>
                <div class="introitem-more">
                  <img src="static/images/home/icon-right01.png" alt="">
                </div>
              </div>
              <div class="introitem">
                <img class="introitem-bg" :src="cultureImg" alt="">
              </div>
              <div class="introitem bg4">
                <div class="introitem-title">
                  <div class="introitem-name">企业文化</div>
                  <div class="introitem-en">COMPANY CULTURE</div>
                </div>
                <div class="introitem-more">
                  <img src="static/images/home/icon-right02.png" alt="">
                </div>
              </div>
              <div class="introitem bg5">
                <div class="introitem-title" style="text-align: right;">
                  <div class="introitem-name">企业荣誉</div>
                  <div class="introitem-en">COMPANY HONOR</div>
                </div>
                <img class="introitem-mask" :src="introMask" alt="">
                <div class="introitem-more">
                  <img src="static/images/home/icon-right03.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 产品中心 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="productImg" alt="">
          </div>
          <div class="carouseitem-con">
            <div class="product-title animated" :class="swiperOption.initialSlide == 2 ? 'delay bounceInDown' : 'fadeOutUp'">
              <div>产品中心</div>
              <img :src="productEn" alt="">
            </div>
            <div  class="product-cate animated" :class="swiperOption.initialSlide == 2 ? 'delay bounceInLeft' : 'fadeOutLeft'">
              <div v-if="false" :class="cateIdx == index ? 'product-catelist on' : 'product-catelist'" v-for="(item, index) in productCate" :key="index" @click="getGoodTab(index)">{{ item.name }}</div>
            </div>
            <div class="product-con animated" :class="swiperOption.initialSlide == 2 ? 'delay bounceInUp' : 'fadeOutDown'">
              <swiper ref="proSwiper" class="product-swiper" :options="productSwiper">
                <swiper-slide v-show="index < 3" v-for="(list, index) in swiperGood" :key="index">
                  <div class="productlist">
                    <div class="productitem" v-for="(item, idx) in list" :key="idx" @click="getProDetail(item.id)">
                      <div class="goodlist-img">
                        <img class="goodlist-bg" :src="goodBg" alt="">
                        <img class="goodlist-thumb" :src="item.thumb" alt="">
                      </div>
                      <div class="goodlist-con">
                        <div class="goodlist-title">{{ item.title }}</div>
                        <div class="goodlist-desc">{{ item.bref }}</div>
                        <div class="goodlist-more">查看更多</div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <div class="product-pagination" slot="pagination"></div>
              </swiper>
              <div class="product-btn">
                <img @click="getProPrev()" :src="proLeft" alt="">
                <img @click="getProNext()" :src="proRight" alt="">
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 新闻资讯 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="newsImg" alt="">
          </div>
          <div class="carouseitem-con">
            <div class="product-title animated" :class="swiperOption.initialSlide == 3 ? 'delay bounceInDown' : 'fadeOutUp'">
              <div>新闻资讯</div>
              <img :src="newsEn" alt="">
            </div>
            <div class="newscon">
              <div v-if="newsList[0]" class="newscon-left animated" :class="swiperOption.initialSlide == 3 ? 'delay bounceInLeft' : 'fadeOutLeft'" @click="getNewsDetail(newsList[0].id)">
                <img :src="newsList[0].thumb" alt="">
                <div class="newscon-title">{{ newsList[0].title }}</div>
                <div class="newscon-time">{{ newsList[0].ctime }}</div>
                <div class="newscon-desc">{{ newsList[0].bref }}</div>
              </div>
              <div class="newscon-right animated" :class="swiperOption.initialSlide == 3 ? 'delay bounceInRight' : 'fadeOutRight'">
                <div class="newscon-list" v-show="index > 0 && index < 4" v-for="(item, index) in newsList" :key="index" @click="getNewsDetail(item.id)">
                  <img class="newslist-img" :src="item.thumb" alt="">
                  <div class="newslist-con">
                    <div class="newslist-title">{{ item.title }}</div>
                    <div class="newslist-time">
                      <div>{{ item.ctime }}</div>
                      <img :src="newsRight" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 企业文化 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="cultureImg" alt="">
          </div>
          <div class="carouseitem-con">
            <div class="product-title animated" :class="swiperOption.initialSlide == 4 ? 'delay bounceInDown' : 'fadeOutUp'">
              <div>企业文化</div>
              <img :src="cultureEn" alt="">
            </div>
            <div class="culturecon animated" :class="swiperOption.initialSlide == 4 ? 'delay bounceInUp' : 'fadeOutDown'">
              <img class="culturecon-img" :src="culImg" alt="">
              <div class="culturecon-imglist">
                <img :src="item.thumb" alt="" v-for="(item, index) in imgList" :key="index">
              </div>
              <div class="culcon-list">
                <div class="culcon-item" v-show="index < 8" v-for="(item, index) in culList" :key="index" @click="getCulDetail(item.id)">
                  <div class="culcon-item-title">
                    <span class="culcon-item-dot"></span>
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="culcon-item-time">
                    <div>{{ item.datetime }}-{{ item.day }}</div>
                    <div>></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="culturecon-scroll animated" :class="swiperOption.initialSlide == 4 ? 'delay bounceInUp' : 'fadeOutDown'" @click="getCulTab">
              <img :src="culScroll" alt="">
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 企业公告 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="noticeImg" alt="">
          </div>
          <div class="carouseitem-con">
            <div class="product-title animated" :class="swiperOption.initialSlide == 5 ? 'delay bounceInDown' : 'fadeOutUp'">
              <div style="color: #002244;">企业公告</div>
              <img :src="noticeEn" alt="">
            </div>
            <div class="noticecon animated" :class="swiperOption.initialSlide == 5 ? 'delay bounceInUp' : 'fadeOutDown'">
              <swiper ref="notSwiper" class="notice-swiper" :options="noticeSwiper">
                <swiper-slide v-show="index < 9" v-for="(list, index) in swiperNotice" :key="index">
                  <div class="noticelist">
                    <div class="noticeitem" v-for="(item, idx) in list" :key="idx" @click="getNotDetail(item.id)">
                      <img class="noticeitem-img" :src="item.thumb" alt="">
                      <div class="noticeitem-title">{{ item.title }}</div>
                      <div class="noticeitem-time">
                        <div>{{ item.ctime }}</div>
                        <img :src="newsRight" alt="">
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <div class="notice-pagination" slot="pagination"></div>
              </swiper>
              <div class="notice-btn">
                <img @click="getNotPrev()" :src="notLeft" alt="">
                <img @click="getNotNext()" :src="notRight" alt="">
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 咨询互动 -->
      <swiper-slide>
        <div class="carouseitem">
          <div class="carouseitem-bg">
            <img :src="footImg" alt="">
          </div>
          <div class="carouseitem-con" style="width: 1350px;">
            <div class="consult-top">
              <div class="consult-left">
                <div class="consult-desc">
                  <div class="consult-title">联系我们</div>
                  <div class="consult-en">CONTACT US</div>
                  <div class="consult-phone">电话：{{ consult.phone }}</div>
<!--                  <div class="consult-email">邮箱：{{ consult.email }}</div>-->
                  <div class="consult-address">地址：{{ consult.address }}</div>
                </div>
                <div class="consult-code">
                  <div>官方客服微信</div>
                  <img :src="codeImg" alt="">
                </div>
              </div>
              <div class="consult-map">
                <img :src="mapImg" alt="">
              </div>
            </div>
            <div class="consult-bottom">
              <div class="consult-bottomcon" style="">
                <img :src="logo" alt="" style="float: left;">
                <div style="color: white;display:inline-block;width: 70%;float: right">
                  <div style="display:inline-block">贵州汉方药业网站 © 2025 ALL Rights Reserved </div>
                  <div style="display:inline-block;margin-left: 20px;">公安备案号：贵公网安备52011502000820号，  <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;text-decoration: none;">黔ICP备18001453号-3</a></div>
                  <div style="color: white;margin-top: 10px;">
                    建议您使用IE9及以上版本、Chrome、Firefox、360等主流浏览器浏览本网站
                  </div>
                </div>
              </div>
              <img class="consult-btn" :src="topImg" alt="" @click="getPrev">
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { getList, getCate, getBanner } from "@/api/index";
export default {
  name: "Home",
  data() {
    return {
      logo: "static/images/logo.png",
      homeImg: "static/images/home/bg-home.png", // 首背景
      homeTitle: "static/images/home/home-title.png", // 首标题
      introduceImg: "static/images/home/bg-introduce.png", // 简介背景
      newsImg: "static/images/home/bg-news.png", // 新闻背景
      productImg: "static/images/home/bg-product.png", // 产品背景
      noticeImg: "static/images/home/bg-notice.png", // 公告背景
      cultureImg: "static/images/home/bg-culture.png", // 文化背景
      footImg: "static/images/home/icon-footer.png", // 咨询背景
      topImg: "static/images/home/icon-top.png", // 向上
      bottomImg: "static/images/home/icon-bottom.png", // 向下
      homeEn: "static/images/home/home-en.png", // 简介标题英文
      introMask: "static/images/home/intro-mask.png", // 简介竖线
      introPlay: "static/images/home/intro-play.png", // 播放
      introBg: "static/images/home/intro-bg.png", // 简介块状图片
      homeImgList: [],
      homeSwiper: {
        loop: true,
        autoplay: true,
        speed: 1000,
      },

      // 产品中心
      productEn: "static/images/production/pro-en.png",
      goodBg: "static/images/production/pro-goodbg.png",
      proLeft: "static/images/home/pro-left.png",
      proRight: "static/images/home/pro-right.png",
      cateIdx: 0,
      productCate: [],
      swiperGood: [],
      goodList: [],
      productSwiper: {
        initialSlide: 0,
        direction: "horizontal",
        pagination: {
          el: '.product-pagination',
          clickable : true,
          bulletClass : 'pro-bullet',
          bulletActiveClass: 'pro-bullet-active',
        }
      },

      // 新闻资讯
      newsEn: "static/images/news/news-en.png",
      newsRight: "static/images/home/news-right.png",
      newsList: [],

      // 企业公告
      noticeEn: "static/images/home/not-en.png",
      notLeft: "static/images/home/not-left.png",
      notRight: "static/images/home/not-right.png",
      swiperNotice: [],
      noticeList: [],
      noticeSwiper: {
        initialSlide: 0,
        direction: "horizontal",
        pagination: {
          el: '.notice-pagination',
          clickable : true,
          bulletClass : 'pro-bullet',
          bulletActiveClass: 'pro-bullet-active',
        }
      },

      // 企业公告
      cultureEn: "static/images/culture/cul-en.png",
      culImg: "static/images/home/cul-img1.png",
      culScroll: "static/images/home/cul-scroll.png",
      imgList: [
        {
          thumb: "static/images/home/cul-img2.png"
        },
        {
          thumb: "static/images/home/cul-img3.png"
        },
        {
          thumb: "static/images/home/cul-img4.png"
        },
      ],
      culList: [],

      // 咨询互动
      codeImg: "static/images/consult/con-code.png",
      mapImg: "static/images/consult/con-map.png",
      consult: {
        phone: "0851-84600262",
        email: "hanfang@ggguuu.com",
        address: "贵州省贵阳市贵阳国家高新技术产业开发区沙文镇创纬路118号"
      },
      swiperOption: {
        initialSlide: 0,
        direction: "vertical",
        speed: 1000,
        grabCursor: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable : true,
          bulletClass : 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
        }
      }, // 整体轮播参数
    }
  },
  methods: {
    // 双击图片
    getHomeImg(url) {
      console.log(url);
      if(url) {
        window.open(url, '_blank');
      }
    },
    // 轮播图change事件
    onSlideChange() {
      this.swiperOption.initialSlide = this.$refs.mySwiper.$swiper.activeIndex;
    },
    // 下一页
    getNext() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    // 上一页
    getPrev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    // 简介查看更多
    getIntroMore() {
      this.$router.push({
        path: "/introduce"
      });
    },
    // 企业简介跳转  跳转路径查看router文件
    toIntro() {
      // this.$router.push({
      //   path: "/introduce"
      // });
    },

    // 产品中心
    // 数组切割
    listPropore(e) {
      let proportion = 3; //按照比例切割
      let num = 0;
      let _data =[];
      for(let i=0;i<e.length;i++){
          if(i % proportion == 0 && i != 0){
              _data.push(e.slice(num,i));
              num = i;
          }
          if((i+1)==e.length){
              _data.push(e.slice(num,(i+1)));
          }
      }
      return _data;
    },
    // 产品类型切换
    getGoodTab(index) {
      this.cateIdx = index;
      getList(1, this.productCate[index].id, 1, "").then((res) => {
        if(res.data.code == 1) {
          this.goodList = res.data.data.rows;
          // 处理产品中心轮播图列表数据
          this.swiperGood = this.listPropore(this.goodList);
        }
      })
    },
    // 产品详情跳转
    getProDetail(id) {
      this.$router.push({
        path: "/production/detail",
        query: { id }
      })
    },
    // 下一页
    getProNext() {
      this.$refs.proSwiper.$swiper.slideNext();
    },
    // 上一页
    getProPrev() {
      this.$refs.proSwiper.$swiper.slidePrev();
    },

    // 新闻资讯
    getNewsDetail(id) {
      this.$router.push({
        path: "/news/detail",
        query: { id }
      })
    },

    // 企业公告
    // 下一页
    getNotNext() {
      this.$refs.notSwiper.$swiper.slideNext();
    },
    // 上一页
    getNotPrev() {
      this.$refs.notSwiper.$swiper.slidePrev();
    },
    getNotDetail(id) {
      this.$router.push({
        path: "/notice/detail",
        query: { id }
      })
    },

    // 企业文化
    getCulTab() {
      this.$router.push({
        path: "/culture"
      })
    },
    getCulDetail(id) {
      this.$router.push({
        path: "/culture/detail",
        query: { id }
      })
    },

    // 咨询互动
  },
  mounted() {
    // 导航栏切换状态滞空
    this.$store.commit("getactive", 0);
    getCate().then((res) => {
      if(res.data.code == 1) {
        var list = res.data.data;
        for(let i in list) {
          getList(list[i].id, null, 1, "").then((pop) => {
            if(pop.data.code == 1) {
              if(list[i].name == '产品中心') {
                this.productCate = [
                  {
                    name: "全部产品",
                    id: 0,
                    pid: list[i].id
                  }
                ]
                getCate(list[i].id).then((prep1) => {
                  var data1 = prep1.data.data;
                  for(let j in data1) {
                    this.productCate.push(data1[j]);
                  }
                })
                this.goodList = pop.data.data.rows;
                // 处理产品中心轮播图列表数据
                this.swiperGood = this.listPropore(this.goodList);
              }
              if(list[i].name == '新闻资讯') {
                this.newsList = pop.data.data.rows;
              }
              if(list[i].name == '企业公告') {
                this.noticeList = pop.data.data.rows;
                // 处理企业公告轮播图列表数据
                this.swiperNotice = this.listPropore(this.noticeList);
              }
              if(list[i].name == '企业文化') {
                this.culList = pop.data.data.rows;
                for(let m in this.culList) {
                  var datetime = this.culList[m].ctime.split("-");
                  this.culList[m].day = datetime[2];
                  this.culList[m].datetime = datetime[0] + '-' + datetime[1];
                }
              }
            }
          })
        }
      }
    })
    getBanner().then((res) => {
      if(res.data.code == 1) {
        this.homeImgList = res.data.data;
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  .carouseitem {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    .carouseitem-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .homeswiper-img {
      width: 100%;
      height: 100%;
      display: block;
      cursor: pointer;
    }
    .carouseitem-hometitle {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 20;
      width: 420px;
      height: 100px;
    }
    .carouseitem-bottom {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      z-index: 20;
      width: 90px;
      margin: auto;
      cursor: pointer;
    }
    .carouseitem-con {
      position: absolute;
      bottom: 0;
      top: 80px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 20;
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .carintro-con {
        width: 100%;
        height: 110px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 20px 0;
        .carintro-title {
          width: 30%;
          font-size: 48px;
          font-family: "PingFang SC-Medium", "PingFang SC";
          font-weight: 500;
          color: #223037;
          img {
            height: 30px;
          }
        }
        .carintro-desc {
          width: 60%;
          font-size: 16px;
          font-weight: 400;
          color: #223037;
          line-height: 30px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          &>span {
            display: block;
            width: 90%;
          }
          .carintro-desc-more {
            color: #4392EC;
            cursor: pointer;
          }
          .carintro-desc-line {
            width: 4px;
            height: 94px;
            background: linear-gradient(0deg, #B1FAFF 0%, #4392EC 100%);
            margin-left: 20px;
          }
        }
      }
      .carintro-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .introitem {
          width: 25%;
          height: 220px;
          padding: 25px;
          box-sizing: border-box;
          position: relative;
          &.bg1 {
            background: linear-gradient(360deg, #B1FAFF 0%, #4392EC 100%);
          }
          &.bg2 {
            background: #FBC567;
          }
          &.bg3 {
            background: #4392EC;
          }
          &.bg4 {
            background: #B1FAFF;
            .introitem-title {
              color: #0499BF;
            }
          }
          &.bg5 {
            background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
            .introitem-title {
              color: #1C39A4;
            }
          }
          .introitem-title {
            color: #fff;
            font-family: "PingFang SC-Medium", "PingFang SC";
            font-weight: 500;
            .introitem-name {
              height: 50px;
              font-size: 36px;
            }
            .introitem-en {
              font-size: 16px;
            }
          }
          .introitem-mask {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 220px;
            z-index: 20;
          }
          .introitem-more {
            position: absolute;
            bottom: 25px;
            right: 25px;
            height: 50px;
            z-index: 30;
            cursor: pointer;
            img {
              height: 100%;
            }
          }
          .introitem-bg {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 30;
          }
          .introitem-play {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 40;
            margin: auto;
            width: 70px;
          }
        }
      }
      .product-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        font-size: 42px;
        font-family: "PingFang SC-Medium", "PingFang SC";
        font-weight: 500;
        img {
          height: 20px;
          margin-top: 10px;
        }
      }
      .product-cate {
        width: auto;
        color: #fff;
        margin: 20px auto;
        display: flex;
        align-items: center;
        .product-catelist {
          padding: 0 15px;
          margin-left: 20px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          border: 1px solid #fff;
          font-size: 16px;
          font-weight: 400;
          box-sizing: border-box;
          cursor: pointer;
          &.on {
            background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
            border: 0;
          }
        }
      }
      .product-con {
        position: relative;
        width: 100%;
        height: 420px;
        .product-btn {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          z-index: 50;
          width: 100%;
          height: 45px;
          display: flex;
          justify-content: space-between;
          img {
            width: 52px;
            height: 45px;
            cursor: pointer;
          }
        }
      }
      .product-swiper {
        width: 100%;
        height: 420px;
        .productlist {
          width: 100%;
          height: 400px;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          .productitem {
            width: 32%;
            height: 100%;
            background-color: #fff;
            overflow: hidden;
            margin-right: 4%;
            .goodlist-img {
              width: 100%;
              position: relative;
              .goodlist-bg {
                width: 100%;
                height: 250px;
                display: block;
              }
              .goodlist-thumb {
                position: absolute;
                z-index: 10;
                bottom: 0;
                top: 0;
                left: 0;
                right: 0;
                margin: auto;
                height: 200px;
                display: block;
              }
            }
            .goodlist-con {
              padding: 0 34px;
              height: 150px;
              background: #fff;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .goodlist-title {
                font-size: 18px;
                font-family: "PingFang SC-Medium", "PingFang SC";
                font-weight: 500;
                color: #002244;
                height: 25px;
                line-height: 25px;
              }
              .goodlist-desc {
                text-align: center;
                font-weight: 400;
                color: #7C828A;
                line-height: 24px;
                margin-bottom: 10px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /*最大行数*/
              }
              .goodlist-more {
                width: 120px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                font-weight: 400;
                color: #7C828A;
                border: 1px solid #DDDDDD;
                cursor: pointer;
              }
            }
          }
          .productitem:last-of-type {
            margin-right: 0;
          }
        }
      }
      .newscon {
        width: 100%;
        height: 525px;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .newscon-left {
          width: 45%;
          height: 100%;
          padding: 10px;
          box-sizing: border-box;
          background-color: #fff;
          cursor: pointer;
          img {
            width: 100%;
            height: 340px;
            display: block;
          }
          .newscon-title {
            width: 100%;
            font-size: 22px;
            font-family: "PingFang SC-Medium", "PingFang SC";
            font-weight: 500;
            color: #223037;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .newscon-time {
            font-weight: 400;
            color: #4392EC;
            margin-bottom: 10px;
          }
          .newscon-desc {
            width: 95%;
            font-weight: 400;
            color: #7C828A;
            line-height: 28px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /*最大行数*/
            padding-top: 10px;
            border-top: 1px solid #ddd;
          }
        }
        .newscon-right {
          width: 51%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
          .newscon-list {
            width: 100%;
            height: 160px;
            display: flex;
            justify-content: space-between;
            padding: 10px;
            box-sizing: border-box;
            background-color: #fff;
            .newslist-img {
              height: 140px;
              display: block;
            }
            .newslist-con {
              width: 50%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .newslist-title {
                width: 100%;
                font-size: 22px;
                font-family: "PingFang SC-Medium", "PingFang SC";
                font-weight: 500;
                color: #223037;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /*最大行数*/
              }
              .newslist-time {
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                font-weight: 400;
                color: #4392EC;
                img {
                  width: 40px;
                  height: 40px;
                }
              }
            }

          }
        }
      }
      .noticecon {
        position: relative;
        width: 100%;
        height: 410px;
        margin-top: 50px;
        .notice-btn {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          z-index: 50;
          width: 100%;
          height: 66px;
          display: flex;
          justify-content: space-between;
          img {
            width: 52px;
            height: 66px;
            cursor: pointer;
          }
        }
      }
      .notice-swiper {
        width: 100%;
        height: 410px;
        .noticelist {
          width: 100%;
          height: 390px;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          .noticeitem {
            width: 32%;
            height: 100%;
            background-color: #fff;
            margin-right: 4%;
            .noticeitem-img {
              width: 100%;
              height: 252px;
              display: block;
            }
            .noticeitem-title {
              width: 100%;
              min-height: 70px;
              padding: 0 20px;
              box-sizing: border-box;
              font-size: 18px;
              font-family: "PingFang SC-Medium", "PingFang SC";
              font-weight: 500;
              color: #002244;
              line-height: 32px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2; /*最大行数*/
            }
            .noticeitem-time {
              width: 100%;
              height: 43px;
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              font-weight: 400;
              color: #4392EC;
              padding: 0 20px;
              box-sizing: border-box;
              img {
                width: 43px;
                height: 43px;
                display: block;
                cursor: pointer;
              }
            }
          }
          .noticeitem:last-of-type {
            margin-right: 0;
          }
        }
      }
      .culturecon {
        width: 80%;
        height: 393px;
        background-color: #fff;
        display: flex;
        margin: 40px auto 0 auto;
        overflow: hidden;
        .culturecon-img {
          width: 35%;
          height: 100%;
          display: block;
        }
        .culturecon-imglist {
          width: 20%;
          height: 100%;
          img {
            width: 100%;
            height: 131px;
            display: block;
          }
        }
        .culcon-list {
          width: 45%;
          height: 100%;
          padding: 30px 20px;
          box-sizing: border-box;
          overflow: hidden;
          .culcon-item {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ddd;
            cursor: pointer;
            .culcon-item-title {
              width: 70%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .culcon-item-dot {
                width: 4px;
                height: 4px;
                border-radius: 2px;
                background: #4392EC;
                display: inline-block;
                margin-right: 5px;
              }
            }
            .culcon-item-time {
              display: flex;
              align-items: center;
              color: #BAC0C8;
              div {
                margin-left: 10px;
              }
            }
          }
        }
      }
      .culturecon-scroll {
        width: 80%;
        margin: 20px auto 0 auto;
        img {
          height: 43px;
          cursor: pointer;
        }
      }
      .consult-top {
        width: 1200px;
        height: 350px;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 20;
        .consult-left {
          width: 45%;
          height: 80%;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          color: #fff;
          .consult-desc {
            width: 380px;
            .consult-title {
              height: 50px;
              line-height: 50px;
              font-size: 36px;
              font-family: "PingFang SC-Medium", "PingFang SC";
              font-weight: 500;
            }
            .consult-en {
              font-size: 18px;
              font-family: "Roboto-Italic", "Roboto";
              color: rgba(177, 250, 255, 1);
              letter-spacing: 2px;
              font-style: italic;
              margin-bottom: 40px;
            }
            .consult-phone, .consult-email, .consult-address {
              font-size: 16px;
              font-weight: 400;
              line-height: 35px;
            }
          }
          .consult-code {
            width: 150px;
            height: 180px;
            background: #4392EC;
            font-size: 16px;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            img {
              width: 138px;
              height: 138px;
            }
          }
        }
        .consult-map {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            // height: 100%;
            display: block;
          }
        }
      }
      .consult-bottom {
        border-top: 1px solid #5C7480;
        width: 100%;
        margin-top: 30px;
        padding-top: 30px;
        .consult-bottomcon {
          width: 1200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #fff;
          margin: auto;
          img {
            height: 56px;
          }
        }
        .consult-btn {
          display: block;
          width: 92px;
          height: 115px;
          margin: 30px auto 0 auto;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<!-- 轮播图样式 -->
<style>
.swiper {
  width: 100%;
  height: 100%;
}
.my-bullet {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(221, 221, 221, 1);
  display: block;
  margin-bottom: 10px;
  cursor: pointer;
}
.my-bullet-active {
  background-color: rgba(177, 250, 255, 1);
  width: 18px;
  height: 18px;
  display: block;
}
.pro-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(221, 221, 221, 1);
  display: inline-block;
  cursor: pointer;
  margin-left: 10px;
}
.pro-bullet-active {
  background-color: rgba(177, 250, 255, 1);
}
.product-pagination, .notice-pagination {
  position: relative;
  z-index: 50px;
  bottom: 20px !important;
  text-align: center;
}
.swiper-container-vertical .swiper-pagination-bullets {
  right: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue